<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.el-button--primary {
  color: #fff;
  background-color: #caaa87;
  border-color: #CAAA87;
}
.el-button--primary.is-disabled {
  color: #fff;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.el-button--primary.is-disabled:hover {
  color: #fff;
  background-color: #eaeaea;
  border-color: #eaeaea;
}
.el-button--primary:hover {
  color: #fff;
  background-color: #e2d2aa;
  border-color: #e2d2aa;
}
.el-button--primary:focus {
  color: #fff;
  background-color: #e2d2aa;
  border-color: #e2d2aa;
}
</style>



// WEBPACK FOOTER //
// src/App.vue